import React, { useEffect, useRef, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import { useFieldArray, useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import validation from "./validation";
import {
  Table,
  Button,
  Modal,
  Form,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import services from "../../API/services";
import { useDispatch, useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDownloadExcel } from "react-export-table-to-excel";
import * as XLSX from "xlsx";
import decodeEntities from "../../Common/DecodeHtml";
import { ErrorMessage } from "@hookform/error-message";
import { InputField } from "components/InputField/InputField";
import ReactGA from "react-ga4";
import { createPropertyLogs } from "../../store/slices/PropertyData";
// import excelFile from "/food_items.xlsx";

const FoodsItems = () => {
  const { userDetail } = useSelector(authenticationSeletor);
  const { AlertIcon } = Imagesdata || {};
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [showItems, setShowItems] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [selectedItemAction, setSelectedItemAction] = useState([]);
  const [importByExcelState, setImportByExcelState] = useState(false);

  const selectAllRef = useRef();
  const dispatch = useDispatch();
  const formateTable = useRef();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({
    ...validation,
    mode: "onSubmit",
    defaultValues: {
      inputs: [
        {
          property_id: userDetail.propertyId,
          name: "",
          gstType: "",
          gstPercent: "",
          price: "",
          quantity: 1,
        },
      ],
    },
  });

  const { gstPercents } = watch()

  const { fields, append, remove, replace } = useFieldArray({
    name: "inputs",
    control,
  });

  const onHide = () => {
    setShow(false);
    remove();
    reset();
    setEditMode();
  };

  const onSubmit = async (payload) => {
    const items = payload.inputs.map((item) => ({
      ...item,
      gstPercent: +item.gstPercent,
      price: +item.price,
    }));
    const realPayload = { items };
    try {
      let res = {};
      let msg = "";
      if (editMode) {
        res = await services.property.updateFoodItems(
          items[0],
          selectedData.id
        );
        msg = "Updated";
      } else {
        res = await services.property.createFoodItemInventory(realPayload);
        msg = "Created";
      }
      if (res.status === 200) {
        if (msg) {
          toast.success(`Food Item ${msg} Successfully`, { autoClose: 1000, pauseOnHover: true, position: "top-right" });
        }
        let params;
        const oldData = selectedData;
        const newData = payload?.inputs[0];
        const operation = {};
        if (oldData?.name != newData?.name) {
          operation.name = `${newData?.name} → ${oldData?.name}`;
        }
        if (oldData?.price != newData?.price) {
          operation.price = `${newData?.price} → ${oldData?.price}`;
        }
        if (oldData?.gstType != newData?.gstType) {
          operation.gstType = `${newData?.gstType} → ${oldData?.gstType}`;
        }
        if (oldData?.gstPercent != newData?.gstPercent) {
          operation.gstPercentage = `${newData?.gstPercent} → ${oldData?.gstPercent}`;
        }
        if (editMode) {
          params = {
            action: `Food Item Modified`,
            actionBy: userDetail?.firstName + ' ' + userDetail?.lastName,
            operation: JSON.stringify(operation),
            propertyId: userDetail?.propertyId
          }
        }
        else {
          params = {
            action: `Food Item Created`,
            actionBy: userDetail?.firstName + ' ' + userDetail?.lastName,
            operation: `${JSON.stringify(items)}`,
            propertyId: userDetail?.propertyId
          }
        }
        dispatch(createPropertyLogs(params))
        onHide();
        getDataHandler();
      }
    } catch (error) { console.error("Error submitting food item:"); }
  };

  const excelSubmit = async () => {
    let count = 0;
    excelData?.map(async (item) => {
      // const realPayload = {
      //   property_id: userDetail.propertyId,
      //   // category_id: Number(item.Category),
      //   name: item.Items,
      //   price: Math.round(Number(item.Price) + (item.Price * 5) / 100),
      // };

      let myPayload = {
        items: [
          {
            property_id: userDetail.propertyId,
            name: item.Items,
            gstType: item.gstType,
            gstPercent: item.gstPercent,
            price: Math.round(Number(item.Price) + (item.Price * 5) / 100),
            quantity: 1
          }
        ]
      }
      try {
        const res = await services.property.createFoodItems(myPayload);
        if (res.status == 200) {
          count++;
        }
      } catch (error) { console.error("Error excelSubmit function."); }
      if (count == excelData?.length) {
        setExcelData([]);
        setImportByExcelState(false);
        getDataHandler();
      }
    });
  };

  const editHandler = (data) => {
    replace({
      property_id: userDetail.propertyId,
      name: data.name,
      gstType: data.gstType,
      gstPercent: Number(data.gstPercent),
      price: data.price,
      quantity: 1,
    });
    setSelectedData(data);
    setShow(true);
    setValue("foodCategory", data.categoryId);
    setValue("itemName", data.name);
    setValue("itemPrice", data.price);
    setEditMode(true);
  };

  const getDataHandler = async () => {
    try {
      const res = await services.property.getFoodItemsProperty(`?property_id=${userDetail?.propertyId}`);
      // const menuCategory = await services.globalService.getMenuCardCategory();
      if (res.status == 200) {
        setTableData(res.data.data);
      }
      // if (menuCategory.status == 200) {
      // setAllCategory(menuCategory.data.data);
      // }
    } catch (error) { console.error("Error getDataHandler function."); }
  };

  const deleteHandler = async (id, msgState = true) => {
    try {
      const res = await services.property.deleteMenuItems(id);
      if (res.status == 200) {
        let params = {
          action: `Food Item Deleted`,
          actionBy: userDetail?.firstName + ' ' + userDetail?.lastName,
          operation: `Item Id - ${id}`,
          propertyId: userDetail?.propertyId
        }
        dispatch(createPropertyLogs(params))
        if (msgState) {
          getDataHandler();
          toast.success(`Food Item Deleted Successfully!`, { autoClose: 1000, pauseOnHover: true, position: "top-right" });
        }
      }
    } catch (error) { console.error("Error deleteHandler function."); }
  };

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "kitchen_items" });
    getDataHandler();
  }, []);

  const importByExcel = async (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const wb = XLSX.read(bufferArray, { type: "buffer" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        resolve(data);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
    promise.then((data) => {
      setExcelData(data);
    });
  };

  const tableRef = useRef();
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Food-Items",
    sheet: "FoodOrders",
  });
  const { onDownload: excelDownLoadFormate } = useDownloadExcel({
    currentTableRef: formateTable.current,
    filename: "bulk Menu Items",
    sheet: "FoodOrders",
  });

  const searchfilter = (text) => {
    const results = tableData.filter((order) => {
      if (text === "") return tableData;
      return (
        order.name +
        // allCategory.find((i) => i.id == order.categoryId)?.name +
        order.price +
        order?.id
      )
        .toString()
        ?.toLowerCase()
        ?.includes(text?.toLowerCase());
    });
    setShowItems(results);
  };

  useEffect(() => { setShowItems(tableData); }, [tableData]);

  const selectAll = (e) => {
    if (e.target.checked) {
      setSelectedItemAction(showItems.map((i) => i.id));
    } else {
      setSelectedItemAction([]);
    }
  };

  const selectItem = (id) => {
    if (selectedItemAction.includes(id)) {
      selectAllRef.current.checked = false;
      setSelectedItemAction(selectedItemAction.filter((i) => i != id));
    } else {
      setSelectedItemAction([...selectedItemAction, id]);
    }
  };

  const deleteSelectedItem = () => {
    let count = 0;
    selectedItemAction.map((item) => {
      deleteHandler(item, false);
      count++;
    });
    if (count == selectedItemAction.length) {
      getDataHandler();
      toast.success(`Food Item Deleted Successfully!`, { autoClose: 1000, pauseOnHover: true, position: "top-right" });
      count = 0;
      setSelectedItemAction([]);
    }
  };

  const addHandler = () => {
    append({
      property_id: userDetail.propertyId,
      name: "",
      gstType: "",
      gstPercent: "",
      price: "",
      quantity: 1,
    });
  };

  const removeHandler = (index) => { remove(index); };

  return (
    <Layout
      title="Food Items"
      buttonTitle="Create Food Item"
      openHandler={() => setShow(true)}
      extraBtnHandler={onDownload}
      extraButton="Export Table"
      searchfilter={searchfilter}
      secondBtn={() => setImportByExcelState(true)}
      secondbuttonTitle="Import Table"
    >
      {selectedItemAction.length > 0 && (
        <Button className="floatingButton" variant="danger" onClick={deleteSelectedItem}>Delete Selected Item</Button>
      )}
      <div className="table-responsive">
        <table className="dashboard-table">
          <thead>
            <tr>
              <th className="text-center">
                <div className="checkboxes__item">
                  <label className="checkbox style-c">
                    <input
                      type="checkbox"
                      onChange={selectAll}
                      ref={selectAllRef}
                    />
                    <div className="checkbox__checkmark"></div>
                  </label>
                </div>
              </th>
              <th>Item Code</th>
              <th>Item Name</th>
              <th>Item Price</th>
              <th>GST INC/EXL</th>
              <th>GST %</th>
              <th>Tax Amount</th>
              <th>Amount Before Tax </th>
              <th>Quntity</th>
              <th>Final Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {showItems?.length > 0 ? (
              showItems?.map((data, key) => {
                return (
                  <tr key={key}>
                    <td className="text-center">
                      <div className="checkboxes__item">
                        <label className="checkbox style-c">
                          <input type="checkbox" checked={selectedItemAction.includes(data.id)} onChange={(e) => selectItem(data.id)} />
                          <div className="checkbox__checkmark"></div>
                        </label>
                      </div>
                    </td>
                    <td data-label="Item Code">{data.itemCode}</td>
                    <td data-label="Item Name">{decodeEntities(data.name)}</td>
                    <td data-label="Item Price">₹{data.price}</td>
                    <td data-label="GST INC/EXL">{data.gstType}</td>
                    <td data-label="GST %">{data.gstPercent}</td>
                    <td data-label="Tax Amount">{data.taxAmount}</td>
                    <td data-label="Amount Before Tax">{data.amountBeforeTax}</td>
                    <td data-label="Quntity">{data.quantity}</td>
                    <td data-label="Final Price">{data.finalPrice}</td>
                    <td data-label="Action">
                      <div className="buttons">
                        <Button variant="primary" className="btn-sm mr-2" onClick={() => editHandler(data)}>
                          <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                        </Button>
                        <Button variant="danger" className="btn-sm" onClick={() => deleteHandler(data.id)}>
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={12}>
                  <div className="flex flex-column align-center justify-content-center full-width" style={{ height: "10rem" }}>
                    <FontAwesomeIcon className="mb-2" icon="fa-solid fa-ban" style={{ width: "40px", height: "40px" }} />
                    <span>No Data</span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <Table striped bordered hover className="common-table text-uppercase d-none" ref={tableRef}>
          <thead>
            <tr>
              <th>Item Code</th>
              <th>Item Name</th>
              <th>Item Price</th>
              <th>GST INC/EXL</th>
              <th>GST %</th>
              <th>Tax Amount</th>
              <th>Amount Before Tax </th>
              <th>Quntity</th>
              <th>Final Price</th>
            </tr>
          </thead>
          <tbody>
            {showItems?.length > 0 ? (
              showItems?.map((data, key) => {
                return (
                  <tr key={key}>
                    <td className="text-center">{data.itemCode}</td>
                    <td>{decodeEntities(data.name)}</td>
                    <td>₹{data.price}</td>
                    <td>{data.gstType}</td>
                    <td>{data.gstPercent}</td>
                    <td>{data.taxAmount}</td>
                    <td>{data.amountBeforeTax}</td>
                    <td>{data.quantity}</td>
                    <td>{data.finalPrice}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={12}>
                  <div className="flex flex-column align-center justify-content-center full-width" style={{ height: "10rem" }} >
                    <FontAwesomeIcon className="mb-2" icon="fa-solid fa-ban" style={{ width: "40px", height: "40px" }} />
                    <span>No Data</span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Modal show={show} onHide={onHide} size="xl">
        <Modal.Header closeButton><Modal.Title>{editMode ? "Edit " : "Add "}Food Item</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form className="popup-form onboardForm" onSubmit={handleSubmit(onSubmit)}>
            <Container>
              <div className="row">
                {fields.map((item, key) => (
                  <div className="field-group-column p-0">
                    {key !== 0 && (<button type="button" className="btn btn-close btn-position" onClick={() => removeHandler(key)}></button>)}
                    <Col xs={3} className="form-group">
                      <InputField
                        htmlFor="name"
                        text="Item Name"
                        type="text"
                        autoFocus={true}
                        placeholder="Enter Item Name"
                        field={`inputs.${key}.name`}
                        register={register}
                        errors={errors}
                      />
                      {errors?.inputs?.[key]?.name?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span><ErrorMessage errors={errors} name={`inputs.${key}.name`} /></span>
                        </div>
                      )}
                    </Col>

                    <Col xs={3} className="form-group">
                      <InputField
                        htmlFor="price"
                        text="Item Price"
                        type="number"
                        autoFocus={true}
                        placeholder="Enter Item Price"
                        field={`inputs.${key}.price`}
                        register={register}
                        errors={errors}
                      />
                      {errors?.inputs?.[key]?.price?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span><ErrorMessage errors={errors} name={`inputs.${key}.price`} /></span>
                        </div>
                      )}
                    </Col>

                    <Col xs={3} className="form-group">
                      <label>Item GST Type</label>
                      <select {...register(`inputs.${key}.gstType`)}>
                        <option selected value="">Select GST Type</option>
                        <option value="INC">Inclusive</option>
                        <option value="EXL">Exclusive</option>
                      </select>

                      {errors?.inputs?.[key]?.gstType?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span><ErrorMessage errors={errors} name={`inputs.${key}.gstType`} /></span>
                        </div>
                      )}
                    </Col>

                    <Col xs={3} className="form-group">
                      <label>Item GST %</label>
                      <select {...register(`inputs.${key}.gstPercent`, { required: 'GST % is required' })}>
                        <option selected value="">Select GST %</option>
                        <option value="5">5%</option>
                        <option value="18">18%</option>
                      </select>
                      {errors?.inputs?.[key]?.gstPercent?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span><ErrorMessage errors={errors} name={`inputs.${key}.gstPercent`} /></span>
                        </div>
                      )}
                    </Col>
                  </div>
                ))}

                <Col xs={12} className="flex justify-content-between pb-2">
                  {editMode ? null : (<span className="btn-link text-decoration-underline" onClick={addHandler}>+ Add New</span>)}
                  <Button className="btn-sm" variant="primary" type="submit">Submit</Button>
                </Col>
              </div>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={importByExcelState} onHide={() => setImportByExcelState(false)} size="lg">
        <Modal.Header closeButton><Modal.Title>Import Bulk Items</Modal.Title></Modal.Header>
        <Modal.Body>
          {excelData?.length > 0 ? (
            <>
              <div className="flex justify-content-end mb-2">
                <button className="btn-sm btn-primary" onClick={excelSubmit}>Submit</button>
              </div>
              <Table striped bordered hover className="common-table">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Item Name</th>
                    <th>Item Price</th>
                    <th>GST Type</th>
                    <th>GST Percent</th>
                    <th>GST Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {excelData?.map((data, key) => {
                    return (
                      <tr key={key}>
                        <td className="text-center">{key + 1}</td>
                        <td>{data.Items}</td>
                        <td>₹{data.Price}</td>
                        <td>{data.gstType}</td>
                        <td>{data.gstPercent}</td>
                        <td>{data.quantity}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </>
          ) : (
            <>
              <div className="flex gap-1 justify-content-between align-items-center ">
                <div className="flex form-group flex-column ">
                  <label htmlFor="excel">Select Excel File</label>
                  <input type="file" id="excel" onChange={(e) => importByExcel(e.target.files[0])} />
                </div>
                <a href="/food_items.xlsx" download className="btn-sm btn-primary text-white">Download Format</a>
              </div>
              <div style={{ position: 'fixed', top: '-9999px', visibility: 'hidden' }}>
                <table className="table border" ref={formateTable}>
                  <thead>
                    <tr>
                      <th>Items</th>
                      <th>Price</th>
                      <th>GST Type</th>
                      <th>GST Percent</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Fried Rice</td>
                      <td>120</td>
                      <td>INC</td>
                      <td>5</td>
                      <td>1</td>
                    </tr>
                    <tr>
                      <td>Zera Rice</td>
                      <td>150</td>
                      <td>EXL</td>
                      <td>5</td>
                      <td>1</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </Layout>
  );
};



export default FoodsItems;
